// extracted by mini-css-extract-plugin
export var label = "_pn-0";
export var link = "_pn-1";